import { render } from "./Mol2DView.vue?vue&type=template&id=fa812b10&scoped=true&ts=true"
import script from "./Mol2DView.vue?vue&type=script&lang=ts"
export * from "./Mol2DView.vue?vue&type=script&lang=ts"

import "./Mol2DView.vue?vue&type=style&index=0&id=fa812b10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa812b10"]])

export default __exports__